<template>
    <div class="failed-dialog">
        <el-dialog v-model="isShowFailedDialog" center :show-close="false" :close-on-click-modal="false">
            <img src="../assets/img/icon-fail.png">
            <div class="title">
                <span v-if="title != ''">
                    {{ title }}
                </span>
                <span v-else>
                    {{ $t("Failed!") }}
                </span>
            </div>
            <div class="desc">
                {{ desc }}
            </div>
            <div class="btn" @click="this.$emit('isShowFailedDialog', false);">
                {{ $t("Close") }}
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'FailedDialog',
        props: ["title", "desc"],
        data() {
            return {
                isShowFailedDialog: true,
            }
        },
    }
</script>

<style lang="scss">
    @import '../assets/styles/base.scss';
    .el-dialog {
        width: 100%;
        max-width: 300px;

        .el-dialog__body {
            text-align: center;
            color: #000;
            
            .title {
                font-size: 24px;
            }

            .desc {
                font-size: $large;
                padding: 10px 0 20px;
            }

            .btn {
                font-weight: bold;
                text-align: center;
                padding: 8px 50px;
                border: 1px solid $brown;
                border-radius: 30px;
                color: $brown;
                cursor: pointer;
            }
        }
    }
</style>